"use client";
import React from 'react';
import { motion } from 'framer-motion';
import { useContactModal } from '../../../../contexts/ContactModalContext';

export default function PerformanceCTA() {
    const { openModal } = useContactModal();

    return (
        <section
            className="relative overflow-hidden py-24 px-6 md:px-16 lg:px-24"
            style={{
                background: '#211a24',
                borderTopLeftRadius: '80px',
                borderTopRightRadius: '80px',
            }}
        >
            <div className="max-w-[900px] mx-auto relative z-10 text-center flex flex-col gap-10 items-center">

                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: '#ceff1a', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                >
                    Get In Touch
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 }}
                    className="text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight"
                    style={{
                        fontFamily: 'var(--font-clash), "Clash Display", sans-serif',
                        color: '#ffffff',
                    }}
                >
                    Looking For A Performance Marketing Agency In Bangalore<br />That Understands Why Customers Buy?
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                    className="max-w-2xl flex flex-col gap-2 text-center"
                    style={{
                        fontFamily: 'var(--font-manrope), Manrope, sans-serif',
                        fontSize: '1rem',
                        lineHeight: '1.9',
                        letterSpacing: '0.02em',
                    }}
                >
                    <p style={{ color: 'rgba(251,253,253,0.70)' }}>Anyone can launch campaigns.</p>
                    <p style={{ color: 'rgba(251,253,253,0.70)' }}>Few agencies understand the people those campaigns are meant to reach.</p>
                    <p style={{ color: 'rgba(251,253,253,0.70)' }}>We combine psychology, Google Ads, Meta Ads, CRO, SEO, and analytics to build sustainable growth systems.</p>
                    <p style={{ color: '#ceff1a', fontWeight: 600 }}>Platforms will evolve. Consumer behaviour will always matter.</p>
                    <p style={{ color: 'rgba(251,253,253,0.70)' }}>Let&apos;s build your growth strategy on the foundation that doesn&apos;t change.</p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="flex flex-col sm:flex-row gap-4 items-center"
                >
                    <button
                        onClick={openModal}
                        className="inline-flex items-center justify-center px-10 py-5 rounded-full font-semibold text-lg transition-all duration-300 hover:scale-105"
                        style={{
                            background: '#ceff1a',
                            color: '#080400',
                            fontFamily: 'var(--font-clash), "Clash Display", sans-serif',
                            letterSpacing: '0.08em',
                        }}
                    >
                        Start a Project →
                    </button>
                </motion.div>

            </div>
        </section>
    );
}
